module.exports = __webpack_public_path__ + "static/media/more-information.b8406d83.jpg";